import { render, staticRenderFns } from "./MarketingCampaignNotifyDetailsIndex.vue?vue&type=template&id=1fc46976&scoped=true"
import script from "./MarketingCampaignNotifyDetailsIndex.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignNotifyDetailsIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketingCampaignNotifyDetailsIndex.vue?vue&type=style&index=0&id=1fc46976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc46976",
  null
  
)

export default component.exports